import { createAction } from 'redux-actions'

const SET_FILTERS = 'SET_FILTERS'
const UPDATE_FILTERS = 'UPDATE_SUBFILTERS'
const CLEAR_FILTERS = 'CLEAR_FILTERS'

const setFilters = createAction(SET_FILTERS)
const clearFilters = createAction(CLEAR_FILTERS)
const updateFilters = createAction(UPDATE_FILTERS)

function dslFiltersState(state = {}, { type, payload }) {
  switch (type) {
    case SET_FILTERS:
      return payload
    case UPDATE_FILTERS: {
      const { groupName, subfilters, activityType, isGroupActive } = payload

      const updatedFilters = state[activityType].map((filter) => {
        if(filter.title === groupName) {
          return {
            ...filter,
            isActive: isGroupActive,
            items: subfilters || filter.items,
          }
        }
        return filter
      })

      return {
        ...state,
        [activityType]: updatedFilters,
      }
    }
    case CLEAR_FILTERS: {
      const { activityType } = payload
      const newFilters = state[activityType].map((filter) => {
        const newSubfilters = filter.items.map((value) => ({
          ...value,
          isChecked: false,
        }))
        return {
          ...filter,
          items: newSubfilters,
          isActive: false,
        }
      })
      return {
        ...state,
        [activityType]: newFilters,
      }
    }
    default:
      return state
  }
}

const SET_QUERY = 'SET_QUERY'
const UPDATE_QUERY = 'UPDATE_QUERY'
const CLEAR_QUERY = 'CLEAR_QUERY'

const setQuery = createAction(SET_QUERY)
const clearQuery = createAction(CLEAR_QUERY)
const updateQuery = createAction(UPDATE_QUERY)

const initState = {
  course_tag: [],
  courses: [],
  highlight_courses: [],
}

function queryFilters(state = initState, { type, payload }) {
  switch (type) {
    case SET_QUERY:
      return payload
    case UPDATE_QUERY:
      const { queryName, activeQueries, isActive } = payload
      const newFilter = isActive
        ? new Set([...state[queryName], ...activeQueries])
        : state[queryName].filter((id) => !activeQueries.includes(id))

      return {
        ...state,
        [queryName]: [...newFilter],
      }
    case CLEAR_QUERY:
      return Object.keys(state).reduce((acc, key) => {
        return {
          ...acc,
          [key]: [],
        }
      }, {})
    default:
      return state
  }
}

const SET_SCHEDULE_STATE = 'SET_SCHEDULE_STATE'
const setScheduleState = createAction(SET_SCHEDULE_STATE)
function scheduleIsShown(state = false, { type, payload }) {
  switch (type) {
    case SET_SCHEDULE_STATE:
      return payload
    default:
      return state
  }
}

const SET_LOCATION_INFO = 'SET_LOCATION_INFO'
const setLocationInfo = createAction(SET_LOCATION_INFO)

function locationInfo(state = {}, { type, payload }) {
  switch (type) {
    case SET_LOCATION_INFO:
      return payload
    default:
      return state
  }
}

export {
  setFilters,
  clearFilters,
  updateFilters,
  setQuery,
  clearQuery,
  updateQuery,
  queryFilters,
  dslFiltersState,
  scheduleIsShown,
  setScheduleState,
  setLocationInfo,
  locationInfo,
}
